require('./discussions.route');
require('./show-discussion.controller');
require('./new-discussion.controller');
require('./edit-discussion.controller');
